const emptyApiImpl = {
    name: 'emptyApi',
    init: () => {
        return 'emptyApiInit';
    },
};
export default emptyApiImpl;
